import bus from '../bus';

import { notify } from '../../mixins/notify.mixin';
import { ErrorHandlerMixin } from '../../mixins/error-handler.mixin';

const notification = require('../Notification.vue').default;
const Main = {
    el: '#header-container',
    mixins: [notify, ErrorHandlerMixin],
    components: {
        notification: notification,
    },
    data: {
        ba_search: '',
        ba: null,
        bas: [],

        drawerOpen: false,
        openAccountDropdown: false,

        show_ie_alert: false,

        notifications: [],
        unread_count: '',
        metadata: {},
    },
    mounted() {
        this.ba = JSON.parse(this.$el.dataset.ba || 'null');
        this.bas = JSON.parse(this.$el.dataset.bas || '[]');

        this.load_notifications();
        this.meta();

        this.ie_check();

        bus.$on('reload', () => this.meta());
    },
    computed: {
        filtered_bas: function () {
            return _.filter(this.bas,this.ba_filter.bind(this)).sort((a,b) => a.name.localeCompare(b.name));
        }
    },
    methods: {
        ie_check() {
            if (window.document.documentMode && !localStorage.getItem('ie_alert_dismissed')) {
                this.show_ie_alert = true;
            }
        },
        ie_alert_dismissed: function () {
            this.show_ie_alert = false;
            localStorage.setItem('ie_alert_dismissed', true);
        },
        ba_filter: function (ba) {
            return ba.name.toLowerCase().indexOf(this.ba_search.toLowerCase()) > -1 || ba.last_four_digits.indexOf(this.ba_search) > -1;
        },
        logoutUser() {
            document.getElementById('logout-form').submit();
        },
        onNotification: function (notif) {
            if (notif.level == 'error') {
                this.notifications.unshift(notif);
                this.process_notifications();
            }
        },
        load_notifications: function () {
            axios
                .get('/notifications?json=true')
                .then((response) => {
                    if (response.status == 200) {
                        let unread_count = response.data.unread_count;
                        if (unread_count) {
                            this.unread_count = unread_count > 99 ? '99+' : unread_count;
                        }

                        this.notifications.unshift(...response.data.data);
                        this.process_notifications();
                    }
                })
                .catch((_error) => {
                    toastr.error(this.errorHandlerResult(_error).message);
                });
        },
        meta: function () {
            axios
                .get('/action-center/metadata?json=true')
                .then((response) => {
                    if (response.status == 200) {
                        this.metadata = response.data;
                    } else {
                        toastr.error('Failed to load metadata: ' + response.status);
                    }
                })
                .catch((_error) => {
                    toastr.error(this.errorHandlerResult(_error).message);
                });
        },
        closeDropdown() {
            this.openAccountDropdown = false;
        },
    },
    directives: {
        'click-away': {
            bind: function (el, binding) {
                const clickEventHandler = (event) => {
                    if (!el.contains(event.target) && el !== event.target) {
                        binding.value(event);
                    }
                };
                el.__vueClickEventHandler__ = clickEventHandler;
                document.addEventListener('click', clickEventHandler);
            },
            unbind: function (el) {
                document.removeEventListener('click', el.__vueClickEventHandler__);
            },
        },
    },
};

if (document.getElementById('header-container')) new Vue(Main);
